import { getSsoPayload } from "@/services/api"

const body = document.body

const injectSsoScript = async () => {
  try {
    const payload = await getSsoPayload()
    const { ssoCheckUrl, isUserLoggedIn, environment } = await payload.data

    window.environment = environment

    if (isUserLoggedIn) return

    const ssoScript = document.createElement("script")

    ssoScript.type = "text/javascript"
    ssoScript.src = ssoCheckUrl

    body && body.appendChild(ssoScript)
  } catch (error) {
    console.log(error)
  }
}

injectSsoScript()
